import {API, Setup} from '../../Services';

async function ServiceList_old_api(){
    let mallId =  localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/service_pages`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function ServiceList_api(tagId=null){
    let mallId =  localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_posts`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            post_type:'service',
            tag__uid:tagId
            // is_introduction:false
        }
    });
}

async function ServiceTags_api(){
    let mallId =  localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_post_tags`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            tag_type:'service',
            // is_introduction:false
        }
    });
}


async function BlogsTags_api(){
    let mallId =  localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_post_tags`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            tag_type:'blog_post',
            // is_introduction:false
        }
    });
}


export {ServiceList_api,ServiceTags_api,BlogsTags_api};
